import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { reviewsCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import * as DateHelper from '@/helpers/date'

// import { midnight, areEqual, formatyyymmdd, dateIn, addDays } from '@/helpers/date'
// import Routine from '@/models/Routine'

// import state from './_state'
// import mutations from './_mutations'
// import actions from './_actions'
// import getters from './_getters'


// const todayTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.today)
// const overdueTask = (task, getters) => task.deadline && task.deadline.toDate() < getters.today
// const tomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.tomorrow)
// const dayAfterTomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.tomorrow, 1))
// const fromTodayTask = (task, getters, n) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.today, n))
// const deadlineAfterTomorrow = (task, getters) => task.deadline && task.deadline.toDate() > addDays(getters.tomorrow, 1)
// const getReviewFor = (task, getters) => !task.done || (task.doneOn && areEqual(task.doneOn.toDate(), getters.today))

const reviewDefaults = (endDate, startDate, period) => {
  return {
    from: startDate,
    to: endDate,
    periodName: 'this week',
    period,
    sentiment: 'good',
    // reflections: [
    //   {
    //     question: 'I should start doing...',
    //     answer: '',
    //     placeholder: 'Do I see anything I should push more?',
    //     questionShort: 'start'
    //   },
    //   {
    //     question: 'I should continue doing...',
    //     answer: '',
    //     placeholder: 'Do I see any good patterns I should follow?',
    //     questionShort: 'continue'
    //   },
    //   {
    //     question: 'I should stop doing...',
    //     answer: '',
    //     placeholder: 'Do I see any bad patterns I should not follow?',
    //     questionShort: 'stop'
    //   },
    // ]
    reflections: [
      {
        question: 'I am the most proud of...',
        answer: '',
        placeholder: '',
        questionShort: 'proud'
      },
      {
        question: 'I am most grateful for...',
        answer: '',
        placeholder: '',
        questionShort: 'grateful'
      },
      {
        question: 'What didn\'t go as planned?',
        answer: '',
        placeholder: '',
        questionShort: 'fuckup'
      },
      // {
      //   question: 'I should stop doing...',
      //   answer: '',
      //   placeholder: 'Do I see any bad patterns I should not follow?',
      //   questionShort: 'stop'
      // },
    ]
  }
}

const decorateReview = (review) => {
  if (review) {
    console.log('review.id', review.id)
    return {...review, to: review.to.toDate(), from: review.from.toDate(), id: review.id  }
  }
}

export default {
  state: {
    reviews: [],
    reviewsDataLoaded: false
  },
  getters: {
    reviewsDataLoaded: (state) => state.reviewsDataLoaded,
    getReview: (state) => (endDate, startDate, period) => {
      // return decorateReview(state.reviews[0])

      return decorateReview(_.chain(state.reviews)
        .filter((review) => review.period === period)
        .filter((review) => DateHelper.areEqual(DateHelper.midnight(review.to.toDate()), DateHelper.midnight(endDate)))
        .filter((review) => DateHelper.areEqual(DateHelper.midnight(review.from.toDate()), DateHelper.midnight(startDate)))
        .first()
        .value()) || reviewDefaults(endDate, startDate, period)
    },
  },
  mutations: {
    setDataLoaded (state) {
      state.reviewsDataLoaded = true
    }
  },
  actions: {
    bindReviews: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef(
        'reviews',
        reviewsCollection.where('uid', '==', currentUserId()),
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
    ADD_REVIEW (_, { review }) {
      console.info('ADD_REVIEW', review)

      const newReview = Object.assign(reviewDefaults(), review, {
        uid: currentUserId(),
        createdAt: timestamp()
      })

      reviewsCollection.add(newReview)
    },
    async DELETE_REVIEW (_, { review }) {
      console.info('DELETE_REVIEW', review)
      reviewsCollection.doc(review.id).delete()
    },
    async UPDATE_REVIEW (_, { review, updateFields }) {
      console.info('UPDATE_REVIEW', review, updateFields)

      // if (updateFields.hasOwnProperty('deadline') || updateFields.hasOwnProperty('showList')) {
      //   console.log('removin list index')
      //   updateFields.listIndex = null
      // }

      reviewsCollection.doc(review.id).update(updateFields)
    },
    // async DELETE_TASK ({ commit }, { task }) {
    //   const data = { task:
    //     { id: task.id,
    //       title: task.title,
    //       done: task.done,
    //       subtasks: task.subtasks,
    //       showList: task.showList,
    //       doneOn: task.doneOn,
    //       backgroundColor: task.backgroundColor,
    //       deadline: task.deadline,
    //     }
    //   }

    //   console.info('DELETE_TASK',
    //     task)
    //   tasksCollection.doc(task.id).delete()

    //   const reverse_detail = 'task deleted'

    //   const action = 'ADD_TASK'


    //   commit('SET_LAST_ACTION', { action, reverse_detail, data })
    // },
  }
}
